<script lang="ts" setup>
import type { HomepageCategoriesProps } from './HomepageMobileCategories.props'
import HomepageMobileCategoryCardWrapper from './HomepageMobileCategoryCardWrapper.vue'

defineProps<HomepageCategoriesProps>()

const selectedTabIndex = ref(0)
const { slider, handleShortcutClick } = useSliderTransition(
  selectedTabIndex.value,
  true
)
</script>

<template>
  <div
    class="crossbrand-mobile-categories"
    :class="version2 && 'crossbrand-mobile-categories--v2'"
  >
    <UtilsTabs
      :tabs="categories"
      :v-model="selectedTabIndex"
      class-buttons-container="flex slider mx-auto w-full max-w-full justify-around relative px-4"
      :wrap-class-title-tab-list="`flex flex-col items-center z-30 bg-neutral-white ${version2 ? 'py-4 max-lg:sticky max-lg:top-0' : 'pt-3'}`"
    >
      <template #tabs-title>
        <h2
          class="my-3 text-center text-[14px]"
          :class="version2 ? 'mb-4 mt-0' : 'mb-3'"
        >
          {{
            version2
              ? $ts('homepage.mobileCategories.v2.title')
              : $ts('homepage.mobileCategories.v1.title')
          }}
        </h2>
      </template>
      <template #button="{ tab, selected, index }">
        <button
          class="text-book-6 text-text-primary basis-1/3 pb-[2px] pt-1 uppercase focus-visible:outline-none"
          :class="{ 'z-10 font-bold': selected, uppercase: version2 }"
          :selected="selected"
          data-tab-controller="true"
          @click="handleShortcutClick(index)"
        >
          <span class="shortcut-element w-fit">
            {{ tab.title }}
          </span>
        </button>
      </template>
      <template #tabs-sufix>
        <div ref="slider" class="slider-tab-border" />
      </template>
      <template #panel="{ tab }">
        <div
          :class="`crossbrand-mobile-categories--card-tab grid px-4 ${version2 ? 'grid-cols-1 gap-11 pb-12 pt-4' : 'grid-cols-2 gap-4 gap-x-2 py-4'}`"
        >
          <HomepageMobileCategoryCardWrapper
            v-for="(card, i) in tab.items"
            :key="i"
            :card="card"
            :fetch-priority-image="false"
            :is-portrait-card="false"
            :index="i"
            :version2="version2"
            :data-testid="`home-brand-card-${card.brand}`"
          />
        </div>
      </template>
    </UtilsTabs>
  </div>
</template>
